var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectionsToPort(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.7852,
    y: 0.11785,
    width: 16.5,
    fill: "none",
    height: 16.5,
    rx: 2.25,
    transform: "rotate(45 11.7852 0.11785)",
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.20653 17.9134C8.80769 17.9134 8.48438 17.5756 8.48438 17.159V13.6097C8.48437 10.6935 10.7476 8.3294 13.5394 8.3294H14.1996L13.1784 6.9446C12.8963 6.65001 12.8963 6.1724 13.1784 5.87781C13.4604 5.58323 13.9176 5.58323 14.1996 5.87781L16.7581 8.55033C17.0402 8.84492 17.0402 9.32254 16.7581 9.61712L14.1996 12.2896C13.9176 12.5842 13.4604 12.5842 13.1784 12.2896C12.8963 11.9951 12.8963 11.5174 13.1784 11.2229L14.1996 9.83806H13.5394C11.5453 9.83806 9.92868 11.5267 9.92868 13.6097V17.159C9.92868 17.5756 9.60536 17.9134 9.20653 17.9134Z",
    fill: "white",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsToPort);
export default __webpack_public_path__ + "static/media/directions-to-port.92b730694bc039cce5e38754c1a39658.svg";
export { ForwardRef as ReactComponent };